import React, { useState } from 'react';

import Carousel from 'react-material-ui-carousel';

import BdsBannerLayout from './BdsBannerLayout/BdsBannerLayout';
import { CAROUSEL_INTERVAL } from '../../../../shared/constants/banner';
import { CLICK_ACTION, SWITCH_BANNER } from '../../../constants/tagManager';
import { IBdsBanner } from '../../../interfaces/bdsBanner';
import TagManagerService from '../../../services/gtm/tagManagerService';

import './BdsBanner.scss';

interface BdsBannerProps {
  banners?: IBdsBanner[];
}

const BdsBanner = ({ banners }: BdsBannerProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const changeBanner = (index: number) => {
    const currentBanner = banners?.[index];
    if (!currentBanner) return;
    const gtmParams = {
      banner_id: currentBanner.id,
      banner_url: currentBanner.callToAction?.route,
      position: index + 1
    };
    TagManagerService.pushEvent(CLICK_ACTION, SWITCH_BANNER, gtmParams);
    setCurrentSlide(index);
  };

  const renderBanners = () => {
    return banners?.map((item, index) => (
      <BdsBannerLayout
        key={item.id}
        banner={item}
        position={index + 1}
        total={banners?.length}
        setSlide={changeBanner}
      />
    ));
  };

  return (
    <Carousel
      className="bds-banner-carousel"
      stopAutoPlayOnHover={true}
      interval={CAROUSEL_INTERVAL}
      navButtonsAlwaysInvisible={true}
      index={currentSlide}
      indicators={false}
    >
      {renderBanners()}
    </Carousel>
  );
};

export default BdsBanner;
